<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>超声在线</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">超声在线</div>
      <p class="fontsize1">
        <span class="con_text">简介：</span><br>
        依托现有的超声影像资源，借助互联网大数据信息技术构建的，
        以市医院超声医学影像科为本区域超声医学影像诊断中心，连接上下层级医疗机构超声医学影像资源，
        提供超声医学影像远程检查、诊断、以微信为信息互通的介质医患双方进行信息传递的新渠道基层医生专家会诊、指导，培训等业务指导和托管服务，实现区域超声医学影像的集中存储、
        管理和影像资料全面共享，并可供卫生管理部门、疾控、临床和病人方便进行查阅的网络信息系统。<br><br>
      </p>
      <div class="con_img"><img src="../../assets/img/Product5s.png" /></div>
      <p class="fontsize1">
        <span class="con_text">主要功能：</span>
        <br>
        超声在线平台的核心功能是医学影像平台<br>
        包含有：远程诊断、远程质控、远程咨询、远程培训、预约查询<br><br>
        <span class="con_text">应用案例：</span>
        <br>
        多云南启秘科技有限公司与昆明市延安医院超声医学中心合作，利用互联网大数据信息技术，搭建的“超声在线”在延安医院与石林县医院、呈贡县医院开展了超声医学远程服务应用。
        项目经过两年的运行，得到了昆明市延安医院超声医学中心的高度认可，一致认为平台应用安全可靠、性能高效、效果良好。<br>
      </p>

    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  mounted () {
    if (document && document.body) {
      document.body.style.margin = '0px';
      this.originalBodyMargin = document.body.style.margin;
    }
  },
  beforeDestroy () {
    if (document && document.body) {
      document.body.style.margin = this.originalBodyMargin || '';
    }
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 80%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>